module.exports = __webpack_public_path__ + "static/media/bg_title_q.99007fd2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/icon/bg_title_q.svg
// module id = 1200
// module chunks = 0